import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getPatientsAnamnesis () {
   return Api().get("/patient-anamneses");
},
  updatePatientAnamnesis (params) {
    return Api().put("/patient-anamneses",params);
  },
  addPatientAnamnesis (params) {
    return Api().post("/patient-anamneses",params);
  },
  getPatientAnamnesis (params) {
    return Api().get("/patient-anamneses/"+params);
  },
  deletePatientAnamnesis (params) {
    return Api().delete("/patient-anamneses/"+params);
  },
  getPatientAnamnesisByRouteSheets(params){
    return Api().get("/patient-anamneses-route-sheet/"+params);
  },
  getExcelMsp(){
    return  axios.create({
      baseURL: 'https://inscora-msp.s3.amazonaws.com/msp-templates',
      headers: {
        'Accept': 'application/json',
        "Access-Control-Allow-Origin": "*",
      }
    }).get("/periodico2.xlsx",  { responseType: 'arraybuffer' })
  },
  getExcelMsp2025(){
    return  axios.create({
      baseURL: 'https://inscora-msp.s3.amazonaws.com/msp-templates',
      headers: {
        'Accept': 'application/json',
        "Access-Control-Allow-Origin": "*",
      }
    }).get("/msp2025.xlsx",  { responseType: 'arraybuffer' })
  },
}



// WEBPACK FOOTER //
// ./src/services/PatientAnamnesisService.js